/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { commitMutation, graphql } from 'react-relay';

import environment from '../RelayEnv';

const mutation = graphql`
  mutation UpdateChannelMutation($input: UpdateChannelInput!) {
    updateChannel(input: $input) {
      channel {
        id
        callbackUrl
        callbackQuery
      }
    }
  }
`;

const commit = function(callbackUrl, callbackQuery, channelID, onSuccess) {
  const variables = {
    input: {
      callbackUrl,
      callbackQuery,
      channelId: channelID,
    },
  };

  return commitMutation(environment, {
    mutation,
    variables,
    onCompleted: onSuccess,
  });
};

export default { commit };
